// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yIWqZiymyUFCI1GnbcmH {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 44px);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.Wo4kUBVgBsFP0d42Ug_0 {
  z-index: 3;
  right: 0;
  position: absolute;
  height: calc(100% - 67pt);
  transition: transform 0.5s;
  overflow: hidden;
  align-self: center;
  display: grid;
  grid-template-columns: minmax(0, 2.25rem) minmax(0, auto);
  user-select: none;
  overscroll-behavior: none;
  width: min(75vw, clamp(380px, 25vw, 33vw));
  pointer-events: auto;
  bottom: 0;
}

#gw-map.is-mobile .yIWqZiymyUFCI1GnbcmH {
  top: -1.5rem;
  bottom: 0;
}

.bSDfC8aQDuhx5n52YRNR {
  transform: translateX(0);
  -webkit-transform: translateX(0);
}

.e1ZKZr3TiiyU5z_Pgd5e {
  transform: translateX(calc(100% - 2.25rem));
  -webkit-transform: translateX(calc(100% - 2.25rem));
}

.EsIsa7Lz3vvrlTF38sKU {
  border-radius: 1rem 0 0 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: tb-rl;
  writing-mode: vertical-rl;
  cursor: pointer;
  height: 70px;
  background-color: var(--map-accent-color);
  align-self: center;
  width: 2.25rem;
  border-top: 2px solid #ffffff;
  border-left: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  box-sizing: content-box;
  transition: filter var(--hover-transition-duration);
  overflow: hidden;
}

@media (hover: hover) {
  .EsIsa7Lz3vvrlTF38sKU:hover {
    filter: brightness(95%);
  }
}

.EsIsa7Lz3vvrlTF38sKU:active {
  filter: brightness(95%);
}

.EsIsa7Lz3vvrlTF38sKU img {
  width: 50%;
  transition: transform 0.5s;
}

.bSDfC8aQDuhx5n52YRNR .EsIsa7Lz3vvrlTF38sKU img {
  transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
}

.Gd_eRBmxoOjIIXuiNQ_v {
  overflow-y: auto;
  height: 100%;
  z-index: 2;
}

.ZM26vGPi2fXIiZaHuoL5 {
  background: linear-gradient(-135deg,#fff,#eeeffc 50%,#eeeffc 75%,#e3e5fa 90%,#d9dbf7);
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: auto;
  border-radius: 2rem 0 0 2rem;
  border-top: 2px solid #00c49a;
  border-left: 2px solid #00c49a;
  border-bottom: 2px solid #00c49a;
}

.nmwjoZvounXYntdElbSA {
  overflow: hidden;
  background: var(--map-background-color-light);
}

.nmwjoZvounXYntdElbSA {
  border-top: var(--border-divider);
}

.BdOdGUrLHqczcxd43xQq {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  box-sizing: border-box;
  background-color: #eeeffc;
  background: linear-gradient(
    -135deg,
    #ffffff 0%,
    #eeeffc 50%,
    #eeeffc 75%,
    #e3e5fa 90%,
    #d9dbf7 100%
  );
  overscroll-behavior: contain;
}

.Xpl3whSNwuafOro5J31v {
  overflow-y: auto;
  overscroll-behavior: contain;
}

.mCRqLSARe5TvaRTiDrc4 {
  background-color: #060a23;
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5rem;
  padding: 1rem 0 1.5rem 0;
  background: linear-gradient(
    135deg,
    #060a23 0%,
    #060a23 75%,
    #0a0e2c 90%,
    #0e1235 100%
  );
  background-color: #060a23;
}

.bK21KZ4aTcFCjB7Te_FA h1.xlVaPQDmlI5CvVmyhY0o {
  font-family: var(--map-heading-font);
  letter-spacing: var(--heading-letter-spacing);
  font-weight: var(--map-h1-font-weight);
  font-size: var(--map-h1-font-size);
  margin-bottom: 0.5rem;
  padding: 0.5rem 0 0 1rem;
  color: white;
}

.R5ZdgSqf4vPdRdEdvX7S {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto auto;
  grid-row-gap: 0.5rem;
  margin: 0 1rem;
}

.J6d38WhwSHY3RBUoGie2 {
  --body-text-color: #fff;
  font-family: var(--map-body-font);
  font-size: var(--map-small-body-font-size);
  font-weight: var(--map-h2-font-weight);
  line-height: 1.2;
}

.eDStcogMzUMZzIr9Crqt {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 1fr;
}

.R5ZdgSqf4vPdRdEdvX7S .GM1ioy2YdYSEC7w94P28 {
  display: flex;
  align-self: center;
}

.R5ZdgSqf4vPdRdEdvX7S .GM1ioy2YdYSEC7w94P28.o3zzw_Ht7dClhVA9ZhYL {
  flex: 0;
  opacity: 0.5;
  margin: 0 0.5rem;
  position: relative;
  border: 1px solid #fff;
  align-self: auto;
}

.R5ZdgSqf4vPdRdEdvX7S a {
  margin: 0;
  padding: 0.25rem;
  display: flex;
  flex: 1;
}

.R5ZdgSqf4vPdRdEdvX7S img {
  width: 0px;
  opacity: 0.5;
  flex: 1;
}

.jnUyMRQLQaG88VciD8BJ {
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: #ebebeb;
  border-bottom: solid 1pt rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  font-size: 1rem;
  cursor: pointer;
  transition: filter var(--hover-transition-duration);
}

.jnUyMRQLQaG88VciD8BJ:hover {
  filter: brightness(95%);
}

@media (hover: hover) {
  .jnUyMRQLQaG88VciD8BJ:hover {
    filter: brightness(95%);
  }
}

.jnUyMRQLQaG88VciD8BJ:active {
  filter: brightness(95%);
}

.aEAVrDXRXAg1si0FYOAL {
  width: 1rem;
  height: auto;
}

#gw-map .jnUyMRQLQaG88VciD8BJ p.map-body {
  padding-left: 0.75rem;
  margin-top: 0;
}

.IcjWGqCYjQnZgMvpyVN7 {
  display: none;
  width: 55%;
  border: solid purple;
}

.Z4jbS2S96t8AEPvd6yi1 {
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 6px;
  padding-right: 6px;
  margin-right: 6px;
  margin-left: 3px;
}

._BQ8BdvjdVfh_IsORbw4 {
  width: 100%;
  height: auto;
  box-sizing: border-box;
}

.wjy_UYgntse5vLEnwOl9 {
  display: block;
  padding: 1rem;
}

.dhlwqhRRFYa_Ir4JKPGW {
  font-family: var(--map-body-font);
  font-size: var(--map-body-font-size);
  color: var(--map-body-color);
  margin-top: 0.125rem;
}

.ZPqelKMEy1pUeWAIcNmu:not(:first-child) {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./../core/components/legend/Legend.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yDAAyD;EACzD,iBAAiB;EACjB,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,mDAAmD;AACrD;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,uBAAuB;EACvB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qFAAqF;EACrF,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB;;;;;;;GAOC;EACD,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,wBAAwB;EACxB;;;;;;GAMC;EACD,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,sCAAsC;EACtC,kCAAkC;EAClC,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,0CAA0C;EAC1C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,4CAA4C;EAC5C,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".legendWrapper {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: calc(100% - 44px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  pointer-events: none;\r\n}\r\n\r\n.legend {\r\n  z-index: 3;\r\n  right: 0;\r\n  position: absolute;\r\n  height: calc(100% - 67pt);\r\n  transition: transform 0.5s;\r\n  overflow: hidden;\r\n  align-self: center;\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 2.25rem) minmax(0, auto);\r\n  user-select: none;\r\n  overscroll-behavior: none;\r\n  width: min(75vw, clamp(380px, 25vw, 33vw));\r\n  pointer-events: auto;\r\n  bottom: 0;\r\n}\r\n\r\n:global(#gw-map.is-mobile) .legendWrapper {\r\n  top: -1.5rem;\r\n  bottom: 0;\r\n}\r\n\r\n.legendOpen {\r\n  transform: translateX(0);\r\n  -webkit-transform: translateX(0);\r\n}\r\n\r\n.legendClose {\r\n  transform: translateX(calc(100% - 2.25rem));\r\n  -webkit-transform: translateX(calc(100% - 2.25rem));\r\n}\r\n\r\n.legendOpenButton {\r\n  border-radius: 1rem 0 0 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  -webkit-writing-mode: vertical-rl;\r\n  -ms-writing-mode: tb-rl;\r\n  writing-mode: vertical-rl;\r\n  cursor: pointer;\r\n  height: 70px;\r\n  background-color: var(--map-accent-color);\r\n  align-self: center;\r\n  width: 2.25rem;\r\n  border-top: 2px solid #ffffff;\r\n  border-left: 2px solid #ffffff;\r\n  border-bottom: 2px solid #ffffff;\r\n  box-sizing: content-box;\r\n  transition: filter var(--hover-transition-duration);\r\n  overflow: hidden;\r\n}\r\n\r\n@media (hover: hover) {\r\n  .legendOpenButton:hover {\r\n    filter: brightness(95%);\r\n  }\r\n}\r\n\r\n.legendOpenButton:active {\r\n  filter: brightness(95%);\r\n}\r\n\r\n.legendOpenButton img {\r\n  width: 50%;\r\n  transition: transform 0.5s;\r\n}\r\n\r\n.legendOpen .legendOpenButton img {\r\n  transform: scaleX(-1);\r\n  -webkit-transform: scaleX(-1);\r\n}\r\n\r\n.legendScrollContainer {\r\n  overflow-y: auto;\r\n  height: 100%;\r\n  z-index: 2;\r\n}\r\n\r\n.legendContent {\r\n  background: linear-gradient(-135deg,#fff,#eeeffc 50%,#eeeffc 75%,#e3e5fa 90%,#d9dbf7);\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n  border-radius: 2rem 0 0 2rem;\r\n  border-top: 2px solid #00c49a;\r\n  border-left: 2px solid #00c49a;\r\n  border-bottom: 2px solid #00c49a;\r\n}\r\n\r\n.subjectDiv {\r\n  overflow: hidden;\r\n  background: var(--map-background-color-light);\r\n}\r\n\r\n.subjectDiv {\r\n  border-top: var(--border-divider);\r\n}\r\n\r\n.subs {\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  box-sizing: border-box;\r\n  background-color: #eeeffc;\r\n  background: linear-gradient(\r\n    -135deg,\r\n    #ffffff 0%,\r\n    #eeeffc 50%,\r\n    #eeeffc 75%,\r\n    #e3e5fa 90%,\r\n    #d9dbf7 100%\r\n  );\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n.animalStory {\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n.title {\r\n  background-color: #060a23;\r\n  display: flex;\r\n  flex-flow: column nowrap;\r\n  gap: 0.5rem;\r\n  padding: 1rem 0 1.5rem 0;\r\n  background: linear-gradient(\r\n    135deg,\r\n    #060a23 0%,\r\n    #060a23 75%,\r\n    #0a0e2c 90%,\r\n    #0e1235 100%\r\n  );\r\n  background-color: #060a23;\r\n}\r\n\r\n.tracker h1.mapTitle {\r\n  font-family: var(--map-heading-font);\r\n  letter-spacing: var(--heading-letter-spacing);\r\n  font-weight: var(--map-h1-font-weight);\r\n  font-size: var(--map-h1-font-size);\r\n  margin-bottom: 0.5rem;\r\n  padding: 0.5rem 0 0 1rem;\r\n  color: white;\r\n}\r\n\r\n.developerLogo {\r\n  display: grid;\r\n  grid-template-columns: auto;\r\n  grid-template-rows: auto auto;\r\n  grid-row-gap: 0.5rem;\r\n  margin: 0 1rem;\r\n}\r\n\r\n.developerText {\r\n  --body-text-color: #fff;\r\n  font-family: var(--map-body-font);\r\n  font-size: var(--map-small-body-font-size);\r\n  font-weight: var(--map-h2-font-weight);\r\n  line-height: 1.2;\r\n}\r\n\r\n.developerContainer {\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.developerLogo .developerItem {\r\n  display: flex;\r\n  align-self: center;\r\n}\r\n\r\n.developerLogo .developerItem.dividerbox {\r\n  flex: 0;\r\n  opacity: 0.5;\r\n  margin: 0 0.5rem;\r\n  position: relative;\r\n  border: 1px solid #fff;\r\n  align-self: auto;\r\n}\r\n\r\n.developerLogo a {\r\n  margin: 0;\r\n  padding: 0.25rem;\r\n  display: flex;\r\n  flex: 1;\r\n}\r\n\r\n.developerLogo img {\r\n  width: 0px;\r\n  opacity: 0.5;\r\n  flex: 1;\r\n}\r\n\r\n.return {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 1rem;\r\n  background-color: #ebebeb;\r\n  border-bottom: solid 1pt rgba(0, 0, 0, 0.15);\r\n  box-sizing: border-box;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: filter var(--hover-transition-duration);\r\n}\r\n\r\n.return:hover {\r\n  filter: brightness(95%);\r\n}\r\n\r\n@media (hover: hover) {\r\n  .return:hover {\r\n    filter: brightness(95%);\r\n  }\r\n}\r\n\r\n.return:active {\r\n  filter: brightness(95%);\r\n}\r\n\r\n.backArrow {\r\n  width: 1rem;\r\n  height: auto;\r\n}\r\n\r\n:global(#gw-map) .return p:global(.map-body) {\r\n  padding-left: 0.75rem;\r\n  margin-top: 0;\r\n}\r\n\r\n.animalColor {\r\n  display: none;\r\n  width: 55%;\r\n  border: solid purple;\r\n}\r\n\r\n.storyButton {\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  padding-left: 6px;\r\n  padding-right: 6px;\r\n  margin-right: 6px;\r\n  margin-left: 3px;\r\n}\r\n\r\n.subImage {\r\n  width: 100%;\r\n  height: auto;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.subContentContainer {\r\n  display: block;\r\n  padding: 1rem;\r\n}\r\n\r\n.subContentBody {\r\n  font-family: var(--map-body-font);\r\n  font-size: var(--map-body-font-size);\r\n  color: var(--map-body-color);\r\n  margin-top: 0.125rem;\r\n}\r\n\r\n.subContentItem:not(:first-child) {\r\n  margin-top: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendWrapper": `yIWqZiymyUFCI1GnbcmH`,
	"legend": `Wo4kUBVgBsFP0d42Ug_0`,
	"legendOpen": `bSDfC8aQDuhx5n52YRNR`,
	"legendClose": `e1ZKZr3TiiyU5z_Pgd5e`,
	"legendOpenButton": `EsIsa7Lz3vvrlTF38sKU`,
	"legendScrollContainer": `Gd_eRBmxoOjIIXuiNQ_v`,
	"legendContent": `ZM26vGPi2fXIiZaHuoL5`,
	"subjectDiv": `nmwjoZvounXYntdElbSA`,
	"subs": `BdOdGUrLHqczcxd43xQq`,
	"animalStory": `Xpl3whSNwuafOro5J31v`,
	"title": `mCRqLSARe5TvaRTiDrc4`,
	"tracker": `bK21KZ4aTcFCjB7Te_FA`,
	"mapTitle": `xlVaPQDmlI5CvVmyhY0o`,
	"developerLogo": `R5ZdgSqf4vPdRdEdvX7S`,
	"developerText": `J6d38WhwSHY3RBUoGie2`,
	"developerContainer": `eDStcogMzUMZzIr9Crqt`,
	"developerItem": `GM1ioy2YdYSEC7w94P28`,
	"dividerbox": `o3zzw_Ht7dClhVA9ZhYL`,
	"return": `jnUyMRQLQaG88VciD8BJ`,
	"backArrow": `aEAVrDXRXAg1si0FYOAL`,
	"animalColor": `IcjWGqCYjQnZgMvpyVN7`,
	"storyButton": `Z4jbS2S96t8AEPvd6yi1`,
	"subImage": `_BQ8BdvjdVfh_IsORbw4`,
	"subContentContainer": `wjy_UYgntse5vLEnwOl9`,
	"subContentBody": `dhlwqhRRFYa_Ir4JKPGW`,
	"subContentItem": `ZPqelKMEy1pUeWAIcNmu`
};
module.exports = ___CSS_LOADER_EXPORT___;
